import { render } from "./FinalSlide.vue?vue&type=template&id=6d121857&scoped=true"
import script from "./FinalSlide.vue?vue&type=script&lang=js"
export * from "./FinalSlide.vue?vue&type=script&lang=js"

import "./FinalSlide.vue?vue&type=style&index=0&id=6d121857&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d121857"]])

export default __exports__